import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { getAgentSocialLinks } from 'features/auth/actions'
import { selectUserData } from 'features/auth/selectors'

const AgentSocialLinksLoader: React.FC = () => {
  const dispatch = useDispatch()
  const user = useSelector(selectUserData, shallowEqual)

  useEffect(() => {
    if (user?.parent) {
      dispatch(getAgentSocialLinks())
    }
  }, [dispatch, user?.id, user?.parent])

  return null
}

export default AgentSocialLinksLoader
